import React from "react";
import BizAirportDrodown from "./BizAirportDropdown";
import { useDestinationContext } from "../../contexts/DestinationContext";
import styled from "styled-components";
import InputDatePicker from "./Datepicker";
import TravelTimeSelect from "./TravelTimeSelect";
import PreferredAirlines from "./PreferredAirLines";
import Dropdown from "./DropdownField";
import DropdownTravelClass from "./DropdownTravelClass";
import DropdownFlightType from "./DropdownFlightType";
import DropdownPaymentType from "./DropdownPaymentType";
import Checkbox from "./Checkbox";
import DropdownRentCar from "./DropdownRentCar";
import DropdownHotel from "./DropdownHotel";
import InputField from "./InputField";
import DropdownMultiSelect from "./DropdownMultiSelect";

const TravelRequirementForm = ({
  data,
  onTravelReqChange,
  errors,
  tripIndex = 0,
}) => {
  return (
    <FormContainer>
      {data?.map((reqEntity) => (
        <RowWrapper>
          {/* {JSON.stringify(reqEntity)} */}
          <FieldWrapper>
            <Checkbox
              isChecked={reqEntity?.isChecked}
              label={reqEntity?.name}
              setIsChecked={(value) =>
                onTravelReqChange({
                  target: { value, name: reqEntity?.label },
                })
              }
              disabled={
                reqEntity?.label === "per_diem" &&
                tripIndex !== 0 &&
                reqEntity?.isChecked
              }
            />
          </FieldWrapper>
          {reqEntity?.label === "per_diem" && (
            <TextFieldWrapper>
              <InputField
                type={"number"}
                isRounded={true}
                disabled={true}
                label=""
                required={false}
                helperText={errors?.["per_diem"]}
                value={reqEntity?.selected || 0}
                // placeholder="Enter amount"
                name={"per_diem"}
                onChange={onTravelReqChange}
              />
            </TextFieldWrapper>
          )}
          {reqEntity?.dropdown && (
            <FieldWrapper>
              <Dropdown
                disabled={!reqEntity?.isChecked}
                label=""
                required={false}
                topOffset="56px"
                error={errors?.[reqEntity?.label]}
                value={reqEntity?.selected}
                placeholder={`Select ${reqEntity.name} Type`}
              >
                {reqEntity?.hasMultipleSelection ? (
                  <DropdownMultiSelect
                    selected={reqEntity?.selected}
                    hotelTypes={reqEntity?.dropdown.map((option) => ({
                      id: option,
                      name: option,
                    }))}
                    name={reqEntity?.label}
                    onHotelSelect={onTravelReqChange}
                  />
                ) : (
                  <DropdownHotel
                    selected={reqEntity?.selected}
                    hotelTypes={reqEntity?.dropdown.map((option) => ({
                      id: option,
                      name: option,
                    }))}
                    name={reqEntity?.label}
                    onHotelSelect={onTravelReqChange}
                  />
                )}
              </Dropdown>
            </FieldWrapper>
          )}
        </RowWrapper>
      ))}
    </FormContainer>
  );
};

export default TravelRequirementForm;

const DateFieldContainer = styled.div`
  flex: 1;
`;

const FormContainer = styled.div`
  margin-top: 1rem;
`;

const FieldWrapper = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  height: auto;
  @media only screen and (max-width: 768px) {
    width: 100%;
  }
`;

const TextFieldWrapper = styled.div`
  width: 50%;
  position: relative;
  bottom: 32px;
  @media only screen and (max-width: 768px) {
    width: 100%;
    position: auto;
    bottom: 0;
  }
`;

const RowWrapper = styled.div`
  display: flex;
  gap: 0.5rem;
  justify-content: space-between;
  margin-top: 0.5rem;
  align-items: baseline;
  height: 3.75rem;
  @media only screen and (max-width: 768px) {
    flex-direction: column;
    height: auto;
    margin-top: 1rem;
  }
`;
